import { UserPermissions } from '@centecomm/portal-service';
import { IconProps } from 'Icons/IconProps';
import React from 'react';
import { RiBankCardLine } from 'react-icons/ri';
import { LaunchDarklyFlags } from 'utils/Hooks/LaunchDarkly/launchDarklyFlags';

import { FeatureConfiguration } from '../../Core/Types/FeatureConfiguration';
import { LoadingContent } from '../../Shared/PageElements/LoadingContent';

const LazyPaymentsPage = React.lazy(() => import('./Pages/PaymentsPage'));

const paymentsConfiguration: FeatureConfiguration = {
    name: 'Payments',
    navigationItem: {
        route: {
            text: 'common:sidebar.featurePaymentsTitle',
            url: '/payments',
            Icon: ({ color, aspect }: IconProps) => <RiBankCardLine size={aspect} color={color} />,
            ownerOperatorRoot: (
                <React.Suspense fallback={<LoadingContent />}>
                    <LazyPaymentsPage />
                </React.Suspense>
            ),
            tenantRoot: null,
        },
        permissions: [UserPermissions.ManageAdminConfig],
    },
    disableFeature: [],
    checkIfEnabledViaSettings: (settings) => {
        if (settings && settings.payment) {
            return settings.payment.visible;
        }

        return false;
    },
    launchDarklyFlags: [LaunchDarklyFlags.Payments],
};

export default paymentsConfiguration;
